import { Component } from '@angular/core';
import { PushService } from '../../services/push-service';
import { Md5 } from '../../services/md5';
import { ModalService } from '../../services/modal.service';
import { Globals } from '../../services/globals';
import { Child } from '../../models/child';
import { AuthenticationService } from '../../services/authentication.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
})
export class LoginPage {

  /**
   * 아동
   */
  private children: Child[];

  /**
   * 인증토큰
   */
  private token: string;

  /**
   * 사용자 아이디
   */
  id: string;

  /**
   * 사용자 비밀번호
   */
  pwd: string;

  /**
   * 아이디 저장 버튼 체크
   */
  chkId: boolean;

  /**
   * 자동로그인 버튼 체크
   */
  chkAutoLogin: boolean;

  /**
  * @constructor
  */
  constructor(
    private $modal: ModalService,
    private $authService: AuthenticationService,
    private $g: Globals,
    private $push: PushService,
    private $router: Router,
    private $local: LocalStorageService,
    private $session: SessionStorageService) {

    this.id = '';
    this.pwd = '';
    this.chkId = false;
    this.chkAutoLogin = false;

    this.init();
  }

  /**
   * Init
   */
  private init() {
    // Local에서 아이디 저장 여부와 아이디를 가져온다.
    const remember = this.$local.getRememberUserId();

    // Local에 아이디 저장 여부가 없을 경우
    if (!remember) return;

    // 아이디 저장 체크 표시
    this.chkId = true;
    // 아이디 Input에 출력
    this.id = this.$local.getUserId();
  }

  /**
   * Login ajax 성공
   * @param data response data
   */
  private requsetLoginSuccess(data) {
    this.children = data.result;
    this.token = data.token;

    // 아동이 없을경우 알림창
    data.result.length >= 1 ?
      this.successLogin() :
      this.$modal.open({
        title: '아동 등록',
        content: '아동 정보가 없습니다.',
      });
  }

  /**
   * 로그인 성공 (아동이 한명일 경우 아동 식별번호 저장)
   */
  private successLogin() {
    // 로컬스토리지에 아이디 저장
    this.$local.setUserId(this.id);
    // 아이디 저장 허용시 로컬스토리지에 플래그 저장
    this.checkUserId();
    // 세션스토리지에 인증 토큰 저장
    this.$session.setAuthorizationToken(this.token);
    // 자동 로그인 허용시 세션 스토리지 인증 토큰을 로컬스토리지에 저장
    this.chkAutoLogin ?
      this.$local.setAuthorizationToken(
        this.$session.getAuthorizationToken()) :
      this.$local.removeAuthorizationToken();
    // 공유 정보에 아동 목록 저장
    this.$g.saveChildren(this.children);
    // 디바이스 토큰 등록
    this.$push.register();
    // 아동 수의 따른 페이지 결정
    this.viewFirstPage();
  }

  /**
   * 아이디 저장 여부의 따른 저장 및 제거
   */
  private checkUserId() {
    this.chkId ?
      this.$local.setRememberUserId() :
      this.$local.removeRememberUserId();
  }

  /**
   * 메인 페이지 출력
   */
  private viewCommonLayout() {
    this.$router.navigate(['/home']);
  }

  /**
   * 아동 선택 출력
   */
  private viewChooseChildrenPage() {
    this.$router.navigate(['/choose-children']);
  }

  /**
   * 아동 수의 따른 페이지 결정
   */
  private viewFirstPage() {
    this.children.length === 1 ?
      this.viewCommonLayout() :
      this.hasChildData();
  }

  /**
   * 선택된 아동의 존배 여부
   */
  private hasChildData() {
    this.$local.getChildNum() ?
      this.viewCommonLayout() :
      this.viewChooseChildrenPage();
  }

  /**
   * 로그인 정보 전송 및 아동 정보 획득. 획득 후 페이지 이동
   */
  onSubmit() {
    const encryptedPwd = Md5.hashAsciiStr(this.pwd).toString();

    this.$authService.login(this.id, encryptedPwd).subscribe(
      data => this.requsetLoginSuccess(data),
      () => this.$modal.open({
        title: '입력 오류',
        content: '정보를 올바르게 입력해주세요.',
      }));
  }

  /**
   * 아이디 & 비밀번호 찾기 페이지로 이동
   */
  findPrivacy() {
    this.$router.navigate(['/find-privacy']);
  }

  /**
   * 개인정보 이용약관 페이지로 이동
   */
  goToTerms() {
    this.$router.navigate(['/terms']);
  }
}
